import { UserStore, trackTimings, APIRequest as Request, alt } from '@reverbdotcom/discovery-ui';
import { configureMParticle } from '@reverbdotcom/commons/dist/elog/mparticle_tracker';
import { parseMeta } from './parse_meta';

import * as I18n from 'i18n-js';
import * as moment from 'moment';

import 'moment/locale/de';
import 'moment/locale/en-au';
import 'moment/locale/en-ca';
import 'moment/locale/en-gb';
import 'moment/locale/en-ie';
import 'moment/locale/en-il';
import 'moment/locale/en-nz';
import 'moment/locale/es';
import 'moment/locale/es-us';
import 'moment/locale/fr';
import 'moment/locale/fr-ca';
import 'moment/locale/ja';

const DISPLAY_CURRENCY_HEADER = 'X-Display-Currency';

const AppInitializer = {
  init() {
    this.initializeAltStores();
    this.initializeAPIRequest();
    this.initializeLocale();
    this.fixFacebookHash();
    this.configureMparticle();
    trackTimings();
  },

  fixFacebookHash() {
    // Facebook adds a strange hash to our url when we log in, which
    // can break tab navigation. This removes it.
    if (window.location.hash === '#_=_') window.location.hash = '';
  },

  initializeAPIRequest() {
    const userConfig = parseMeta('current-user');

    if (userConfig) {
      Request.setDefaultHeader(DISPLAY_CURRENCY_HEADER, userConfig.user.currency);
    }
  },

  initializeLocale() {
    const userConfig = parseMeta('current-user');
    const translation = parseMeta('js-translations');

    if (userConfig) {
      if (UserStore.isExperimentEnabled('five_digit_locales')) {
        I18n.locale = UserStore.fiveDigitLocale() || I18n.defaultLocale;
      } else {
        I18n.locale = userConfig.user.locale || I18n.defaultLocale;
      }

      moment.locale(I18n.locale);

      if (translation) {
        I18n.translations[I18n.locale.slice(0, 2)] = translation;
      }
    }
  },

  initializeAltStores() {
    const stores = document.getElementById('alt-bootstrap');
    if (stores) {
      alt.bootstrap(stores.textContent);
    }
  },

  configureMparticle() {
    if (process.env.IS_SELENIUM === 'true') return;

    const userConfig = parseMeta('current-user');
    const appConfig = parseMeta('app-config-meta');

    if (userConfig && appConfig) {
      configureMParticle(userConfig.user, appConfig.config.inverseReverseExchangeRates);
    }
  }
};

export default AppInitializer;



// WEBPACK FOOTER //
// ./javascripts/components/app_initializer.js